var domFunctions = require('../utils/_domFunctions');
var urlUtils = require('../utils/_urlUtils');
class oWishlist extends HTMLDivElement {
    constructor() {
        super();
        this.items = this.querySelectorAll('.wishlist-item');
        this.productLineItems = this.querySelectorAll('[data-component-product]');
        this.productToDelete = {
            uuid: '',
            pid: '',
            actionUrl: ''
        };
        this.removeModal = document.querySelector('#m-popin-remove-item-wishlist');
        this.confirmDelete = this.removeModal.querySelector('[data-component-confirm-delete]');

        this.onDeleteProductWishlist = this.onDeleteProductWishlist.bind(this);
    }

    connectedCallback() {
        this.addEventsProductLineItems();
        this.addEventDeleteProductWishlist();
    }

    disconnectedCallback() {
        this.confirmDelete.removeEventListener('click', this.onDeleteProductWishlist);
    }

    addEventsProductLineItems() {
        this.productLineItems.forEach((pli) => {
            var removeButton = pli.querySelector('[data-component-remove-item]');
            domFunctions.onEvent(removeButton, 'click', (e) => {
                e.preventDefault();
                this.productToDelete.uuid = removeButton.dataset.uuid;
                this.productToDelete.pid = pli.dataset.pid;
                this.productToDelete.actionUrl = removeButton.dataset.action;
            });
        });
    }

    addEventDeleteProductWishlist() {
        this.confirmDelete.addEventListener('click', this.onDeleteProductWishlist);
    }

    onDeleteProductWishlist() {
        var urlParams = {
            pid: this.productToDelete.pid
        };

        var url = urlUtils.appendToUrl(this.productToDelete.actionUrl, urlParams);
        fetch(url, {
            method: 'GET'
        }).then((response) => {
            return response.json();
        }).then((responseData) => {
            if (responseData.success) {
                if (responseData.listIsEmpty) {
                    domFunctions.replaceHtml(this, responseData.emptyListTemplate);
                } else {
                    const item = this.querySelector('.uuid-' + this.productToDelete.uuid);
                    domFunctions.removeNode(item);
                }
            }
        });
    }
}

customElements.define('o-wishlist', oWishlist, {
    extends: 'div'
});
